
<ng-template #content let-modal>
	<div class="card border-0">
		<div class="card-header d-flex justify-content-between align-items-center">
			<h4 class="mb-0 text-truncate">{{ notifications[notificationIndex].title}}</h4>
			<i style="cursor: pointer" class="fa float-right fa-times close-icon" (click)="modal.dismiss('click')" aria-hidden="true"></i>
		</div>
		<div class="modal-body" >
			<p [innerHTML]="notifications[notificationIndex].text"></p>
		</div>
		<div class="modal-footer d-flex justify-content-between">
			<small class="text-muted">Released on: {{ notifications[notificationIndex].releaseDate | date : 'longDate' }}</small>
			<button type="button" class="btn btn-primary mb-5" (click)="modal.dismiss('click')" tabindex="-1">Close</button>
		</div>
	</div>
</ng-template>

<button
	type="button"
	autoclose="false"
	container="body"
	placement="bottom right"

	[ngbPopover]="popContent"
	[popoverTitle]="popTitle"
	popoverClass="notification-popover"
	[autoClose]="true"
	triggers="manual"
	#p="ngbPopover"


	(click)="toggleOpen()"
	class="noprint btn btn-primary float-right">
	<div class="notification-wrapper noprint">
		<i [ngClass]="{ 'faa-ring': notificationCount > 0 && !this.popover.isOpen() }" class="fa fa-bell" aria-hidden="true"></i>
		<span class="notification-indicator" *ngIf="notificationCount > 0">{{ notificationCount }}</span>
	</div>

</button>
<ng-template #popTitle>
	</ng-template>
<ng-template #popContent>

	<div
		class="h-100 d-flex justify-content-center align-items-center"
		*ngIf="notificationCount <= 1 && notifications.length <= 1"
>
<h5><i class="fa fa-check-circle-o" style="font-size: 1em; color: #4caf4f" aria-hidden="true"></i> You're all caught up!</h5>
</div>

	<button class="btn bnt btn-outline-secondary text-dark mb-1 btn-block btn-sm" (click)="markAllRead()" *ngIf="notificationCount >= 1">
		<i class="fa fa-check-circle-o" style="font-size: 1em; color: #4caf4f9c" aria-hidden="true"></i> Mark all as read
	</button>
	<div class="notification-list" *ngFor="let notification of notifications; let i = index">
		<div class="notification-item list-group-item  border rounded" (click)="open(content, i)">
			<div class="d-flex justify-content-between">
				<div class="mr-1" [ngClass]="{ 'notification-indicator-item': !notification.viewed, 'notification-indicator-item-off': notification.viewed }">&nbsp;</div>
				<h5 class="mb-1 text-dark flex-md-shrink-0 font-weight-bold">

					<div class="notification-title text-truncate">{{ notification.title }}</div>

				</h5>
				<span class="text-muted d-none d-sm-inline">{{ notification.releaseDate | date : 'mediumDate' }}</span>
			</div>
			<p class="mb-1" [innerHTML]="notification.text | stripHtml | truncate : 100"></p>
			<a class="read-more-link pr-3">Read More</a>
		</div>
	</div>
</ng-template>

